import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
import { interpret } from "xstate";
import simplebar from "simplebar-vue";
import { Guid } from "guid-typescript";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import commentMachine from "../machines/commentMachine";
import { PAReviewCommentItemModel } from "@/store/models/paReview/paReviewCommentItemDTO";
import { qnaFlagsType } from "@/store/models/paReview/paReviewFormDetailItemDTO";
import { PAReviewModule } from "@/store/modules/paReview.module";
let CommentComponent = /** @class */ (() => {
    var _a, _b, _c, _d;
    let CommentComponent = class CommentComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isCommentDirty = false;
            this.commentText = "";
            this.internalComment = null;
            // MACHINE
            this.machine = commentMachine.withContext({
                commentText: "",
                commentCreated: false,
                operationMode: "",
                isNewComment: false,
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        writeComment() {
            this.isCommentDirty = true;
            this.machineService.send({ type: "SHOW_COMMENTING_BOX" });
        }
        saveComment() {
            if (PAReviewModule.openedByClient) {
                this.internalComment.employeeId = this.qnaFlags.assignmentId;
            }
            this.internalComment.comments = this.commentText;
            this.machineService.send({ type: "SAVE_COMMENT", comment: this.internalComment });
            this.isCommentDirty = false;
        }
        cancelComment() {
            this.machineService.send({ type: "CANCEL_COMMENTING_BOX" });
            this.isCommentDirty = false;
            if (this.isNewComment) {
                this.commentText = "";
            }
            else {
                this.commentText = this.comment.comments;
            }
        }
        editComment(newComment) {
            this.machineService.send({ type: "SHOW_COMMENTING_BOX" });
        }
        checkForNewValue() {
            if (this.comment.comments == this.commentText) {
                this.isCommentDirty = false;
            }
            else {
                this.isCommentDirty = true;
            }
        }
        deleteComment(id) {
            this.machineService.send({ type: "DELETE_COMMENT", commentId: id });
            this.deletedComment(id);
        }
        editedComment(newComment) { }
        deletedComment(id) { }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var prevState = this.state;
                this.state = state;
                console.log(this.state.toStrings());
                if (this.state.matches("uncommented") && prevState.matches("savingComment")) {
                    this.internalComment = new PAReviewCommentItemModel();
                    this.internalComment.paCycleReviewAnswerId = this.paReviewAnswerId;
                    this.commentText = this.internalComment.comments;
                }
            });
            if (this.isNewComment !== undefined && this.isNewComment === true) {
                this.internalComment = new PAReviewCommentItemModel();
                this.internalComment.paCycleReviewAnswerId = this.paReviewAnswerId;
            }
            else {
                this.internalComment = this.comment;
            }
            const isNewCommentInternal = !!this.isNewComment;
            this.machineService.send({ type: "INITIALIZE", commentText: this.internalComment.comments, isNewComment: isNewCommentInternal });
            this.commentText = this.internalComment.comments;
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof PAReviewCommentItemModel !== "undefined" && PAReviewCommentItemModel) === "function" ? _a : Object)
    ], CommentComponent.prototype, "comment", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_b = typeof qnaFlagsType !== "undefined" && qnaFlagsType) === "function" ? _b : Object)
    ], CommentComponent.prototype, "qnaFlags", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], CommentComponent.prototype, "isNewComment", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_c = typeof Guid !== "undefined" && Guid) === "function" ? _c : Object)
    ], CommentComponent.prototype, "paReviewAnswerId", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CommentComponent.prototype, "editedComment", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Guid !== "undefined" && Guid) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], CommentComponent.prototype, "deletedComment", null);
    CommentComponent = __decorate([
        Component({
            name: "CommentComponent",
            components: {
                Loader,
                simplebar,
            },
        })
    ], CommentComponent);
    return CommentComponent;
})();
export default CommentComponent;
